@if (editing()) {
  <div class="hd-own-line-text__editor" (click)="$event.stopPropagation()">
    @if (conflict(); as other) {
      <!-- Iemand anders sloeg op na het openen van deze editor: de server heeft niets overschreven. -->
      <div class="hd-own-line-text__notice hd-own-line-text__notice--conflict" role="alert" data-test-id="own-line-text-conflict">
        <p class="hd-own-line-text__notice-title">{{ t('humanDesign.chart.lineTextReview.conflictTitle', { name: other.updatedByDisplayName ?? '?' }) }}</p>
        <p class="hd-own-line-text__notice-text">{{ other.text ?? text() }}</p>
        <div class="hd-own-line-text__actions">
          <button type="button" class="hd-own-line-text__action hd-own-line-text__action--save" data-test-id="own-line-text-adopt" (click)="adoptOther(other)">
            {{ t('humanDesign.chart.lineTextReview.adoptOther') }}
          </button>
          <button type="button" class="hd-own-line-text__action" [disabled]="busy()" data-test-id="own-line-text-overwrite" (click)="overwriteOther(other)">
            {{ t('humanDesign.chart.lineTextReview.overwriteOther') }}
          </button>
        </div>
      </div>
    } @else if (remoteNotice(); as other) {
      <!-- Live seintje: een andere reviewer sloeg deze tekst net op terwijl jij bewerkt. -->
      <div class="hd-own-line-text__notice" role="status" data-test-id="own-line-text-remote">
        <p class="hd-own-line-text__notice-title">{{ t('humanDesign.chart.lineTextReview.remoteTitle', { name: other.updatedByDisplayName ?? '?' }) }}</p>
        <p class="hd-own-line-text__notice-text">{{ other.text ?? text() }}</p>
        <div class="hd-own-line-text__actions">
          <button type="button" class="hd-own-line-text__action" data-test-id="own-line-text-remote-adopt" (click)="adoptOther(other)">
            {{ t('humanDesign.chart.lineTextReview.adoptOther') }}
          </button>
          <button type="button" class="hd-own-line-text__action hd-own-line-text__action--quiet" data-test-id="own-line-text-remote-dismiss" (click)="dismissRemoteNotice()">
            {{ t('humanDesign.chart.lineTextReview.keepMine') }}
          </button>
        </div>
      </div>
    }
    <textarea
      #editor
      class="hd-own-line-text__textarea"
      cdkTextareaAutosize
      cdkAutosizeMinRows="2"
      cdkAutosizeMaxRows="9"
      [value]="draft()"
      [attr.aria-label]="t('humanDesign.chart.lineTextReview.editorLabel')"
      (input)="draft.set(editor.value)"
      (keydown)="onEditorKeydown($event)"
    ></textarea>
    <div class="hd-own-line-text__actions">
      <button
        type="button"
        class="hd-own-line-text__action hd-own-line-text__action--save"
        [disabled]="busy() || draft().trim().length === 0 || conflict() !== null"
        [title]="t('humanDesign.chart.lineTextReview.saveHint')"
        data-test-id="own-line-text-save"
        (click)="save()"
      >
        <i class="fa-solid fa-check" aria-hidden="true"></i>
        <span>{{ t('humanDesign.chart.lineTextReview.save') }}</span>
      </button>
      <button
        type="button"
        class="hd-own-line-text__action"
        [disabled]="busy()"
        data-test-id="own-line-text-cancel"
        (click)="cancelEdit()"
      >
        {{ t('humanDesign.chart.lineTextReview.cancel') }}
      </button>
      @if (edited() || draft() !== text()) {
        <button
          type="button"
          class="hd-own-line-text__action hd-own-line-text__action--quiet"
          [disabled]="busy()"
          [title]="t('humanDesign.chart.lineTextReview.restoreSourceHint')"
          data-test-id="own-line-text-restore"
          (click)="restoreSource()"
        >
          {{ t('humanDesign.chart.lineTextReview.restoreSource') }}
        </button>
      }
    </div>
  </div>
} @else {
  <span class="hd-own-line-text__marker" aria-hidden="true">◆</span><span class="hd-own-line-text__text">{{ effectiveText() }}</span>
  @if (canReview()) {
    <span class="hd-own-line-text__review" [title]="reviewerTitle()">
      <button
        type="button"
        class="hd-own-line-text__button hd-own-line-text__button--approve"
        [class.is-approved]="approved()"
        [disabled]="busy()"
        [attr.aria-pressed]="approved()"
        [attr.aria-label]="approved() ? t('humanDesign.chart.lineTextReview.unapprove') : t('humanDesign.chart.lineTextReview.approve')"
        [title]="approved() ? t('humanDesign.chart.lineTextReview.unapprove') : t('humanDesign.chart.lineTextReview.approve')"
        data-test-id="own-line-text-approve"
        (click)="toggleApproved($event)"
      >
        <i class="fa-circle-check" [class.fa-solid]="approved()" [class.fa-regular]="!approved()" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="hd-own-line-text__button"
        [disabled]="busy()"
        [attr.aria-label]="t('humanDesign.chart.lineTextReview.edit')"
        [title]="t('humanDesign.chart.lineTextReview.edit')"
        data-test-id="own-line-text-edit"
        (click)="startEdit($event)"
      >
        <i class="fa-regular fa-pen" aria-hidden="true"></i>
      </button>
      @if (edited()) {
        <i class="fa-regular fa-pen-line hd-own-line-text__edited" aria-hidden="true" data-test-id="own-line-text-edited"></i>
      }
    </span>
  }
}
